module.exports = __webpack_public_path__ + "static/media/unblock.4fe50038.svg";